import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx, translateTemplateText } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ListTemplateCategory } from '../../client/types';
import { getColor } from '../../helpers/color';
import { CategoryIcon } from '../common/CategoryIcon';
import { TemplateItem } from './TemplateItem';

interface TemplateListProps {
  categories: ListTemplateCategory[];
  selectedCategory: string;
  selectedTemplateId: string | null;
  preselectedTemplateId: string | null;
  onTemplateSelect: (templateId: string) => void;
}

export const TemplateList: FC<TemplateListProps> = ({
  categories,
  selectedCategory,
  selectedTemplateId,
  preselectedTemplateId,
  onTemplateSelect,
}) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ px: '16px' }}>
      <Stack spacing={2}>
        {categories.map(category => (
          <Stack key={category.id} spacing="8px">
            {(selectedCategory === 'all' || preselectedTemplateId) && (
              <Stack direction="row" alignItems="center" gap="6px">
                <CategoryIcon
                  icon={category.icon}
                  iconColor={category.iconColor}
                  customIcon={category.customIcon}
                  type="filled"
                  size={14}
                  color={getColor(category.iconColor)}
                />
                <Text style={{ fontSize: '13px', fontWeight: 600, color: 'var(--tg-theme-section-header-text-color)' }}>
                  {translateTemplateText(t, category.id, 'name', category.name)}
                </Text>
              </Stack>
            )}
            <Box sx={{ width: '100%', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
              <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
                {category.quests.map((template, index) => (
                  <TemplateItem
                    key={template.id}
                    name={translateTemplateText(t, template.id, 'name', template.name)}
                    description={translateTemplateText(t, template.id, 'description', template.description ?? '')}
                    isSelected={selectedTemplateId === template.id}
                    showDivider={index > 0}
                    onClick={() => onTemplateSelect(template.id)}
                  />
                ))}
              </Box>
            </Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
